export async function loadStrings(locale) {
  if (locale === void 0) {
    locale = 'en';
  }
  return import(`./assets/locales/messages_${locale}.json`);
}
//# sourceMappingURL=i18n.js.map